import React, { useState } from 'react';
import { MessageCircle } from 'lucide-react';

const WhatsAppButton = ({ phoneNumber = "5554981000046" }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const whatsappLink = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      aria-label="Fale conosco no WhatsApp"
    >
      <MessageCircle className="whatsapp-icon" />
      {isHovered && (
        <span className="whatsapp-tooltip">
          Fale conosco
        </span>
      )}
    </a>
  );
};

export default WhatsAppButton;
